<script>
export default {
  emits: ['set-password', 'clear-form'],
  props: {
    plabel: {
      type: String,
      default: 'Password',
    },
    clabel: {
      type: String,
      default: 'Confirm Password',
    },
    resetScreen: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: Array,
      default: null,
      required: false,
    },
  },
  data() {
    return {
      passowrdLabel: this.plabel,
      confirmLabel: this.clabel,
      resetscreen: this.resetScreen,
      visibility: 'mdi-eye',
      visibilityOff: 'mdi-eye-off',
      password: '',
      passwordConfirm: '',
      passwordType: 'password',
      passwordConfirmType: 'password',
      passwordPattern:
        /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-])\S{8,}$/,
      passwordRules: [
        (v) => !!v || 'Password is required',
        (v) =>
          this.passwordPattern.test(v) ||
          'Passwords does not meet requirements',
      ],
      confirmRules: [
        (v) => !!v || 'Confirm password is required',
        (v) => (v && this.matchingPasswords) || 'Passwords do not match',
      ],
    }
  },
  computed: {
    iconType() {
      return this.passwordType === 'password'
        ? this.visibilityOff
        : this.visibility
    },
    iconConfirmType() {
      return this.passwordConfirmType === 'password'
        ? this.visibilityOff
        : this.visibility
    },
    matchingPasswords() {
      if (
        this.password !== '' &&
        this.passwordConfirm !== '' &&
        this.password === this.passwordConfirm &&
        this.passwordPattern.test(this.password)
      ) {
        this.$emit('set-password', this.password)
        return true
      } else {
        return false
      }
    },
    success() {
      return (
        !!this.password &&
        !!this.passwordConfirm &&
        this.passwordConfirm === this.password
      )
    },
    successMessage() {
      if (
        this.password !== '' &&
        this.passwordConfirm !== '' &&
        this.passwordConfirm === this.password
      ) {
        return ['Passwords match']
      } else {
        return []
      }
    },
    selectedCSSClass() {
      return this.resetscreen
        ? this.$style.text
        : [this.$style.text, 'col-md-6 col-lg-6 col-xl-6']
    },
    selectedCol() {
      return this.resetscreen ? 10 : 12
    },
  },
  watch: {
    passwordConfirm(val) {
      this.$refs.pass.validate()
    },
    password(val) {
      this.$refs.conPass.validate()
    },
  },
  methods: {
    toggleType() {
      this.passwordType = this.passwordType === 'text' ? 'password' : 'text'
    },
    toggleConfirmType() {
      this.passwordConfirmType =
        this.passwordConfirmType === 'text' ? 'password' : 'text'
    },
  },
}
</script>

<template>
  <v-row>
    <v-col :cols="selectedCol" :class="selectedCSSClass" class="py-0">
      <div class="mb-2" :class="$style.labelText"
        >{{ passowrdLabel }}<span :class="$style.mandatory">*</span></div
      >
      <v-text-field
        key="password"
        ref="pass"
        v-model="password"
        hide-details="auto"
        :type="passwordType"
        :rules="passwordRules"
        :error="passwordConfirm !== '' && !matchingPasswords"
        :error-messages="[]"
        :success="success"
        :success-messages="[]"
        autocomplete="off"
        :class="$style.passTextField"
        outlined
        :append-icon="iconType"
        style="font-size: 12px !important"
        dense
        @click:append="toggleType"
      ></v-text-field>
    </v-col>

    <v-col :cols="selectedCol" :class="selectedCSSClass" class="py-0">
      <div class="mb-2" :class="$style.labelText"
        >{{ confirmLabel }}<span :class="$style.mandatory">*</span></div
      >
      <v-text-field
        key="confirmPassword"
        ref="conPass"
        v-model="passwordConfirm"
        hide-details="auto"
        :type="passwordConfirmType"
        autocomplete="off"
        style="font-size: 12px !important"
        dense
        :error-messages="errorMessage ? errorMessage : ''"
        :success="success"
        :success-messages="successMessage"
        :class="$style.passTextField"
        outlined
        :rules="confirmRules"
        :append-icon="iconConfirmType"
        @click:append="toggleConfirmType"
        @keydown="
          errorMessage && errorMessage.length ? $emit('clear-form') : null
        "
      ></v-text-field>
    </v-col>
  </v-row>
</template>

<style lang="scss" module>
@import '@design';
.labelText {
  font-size: 12px !important;
  font-weight: 700;
}
.text {
  margin: 0.5rem auto;
  color: #2c3a4b;
}
.mandatory {
  color: #da1414;
}
.passTextField {
  font-size: 12px !important;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.75px;
}
</style>

<style scoped>
/* custom css to override vuetify classes */
/* stylelint-disable */
/deep/ .theme--light.v-input input {
  font-size: 12px !important;
}
/* stylelint-enabled */
</style>
